import React from "react";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { View, ViewType } from "@common/types/views/views";
import {
    receiptSendersViewConfig,
    ReceiptSenderColumn,
    ReceiptSenderRow,
} from "./receiptSendersViewConfig";

const defaultView: View = {
    type: ViewType.RECEIPT_SENDER,
    columns: [
        { id: ReceiptSenderColumn.EMAIL },
        { id: ReceiptSenderColumn.LIMIT },
        { id: ReceiptSenderColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
    },
};

interface ReceiptSendersViewProps {
    data: ReceiptSenderRow[] | null;
}

export const ReceiptSendersView: React.FC<ReceiptSendersViewProps> = ({
    data,
}) => (
    <ViewTable
        data={data}
        view={defaultView}
        config={receiptSendersViewConfig}
        emptyView={() => (
            <EmptyState
                header="No emails yet"
                body="Add an email to submit your receipts to receipts@kick.co"
            />
        )}
        enableColumnResizing={false}
        outerBorder
    />
);
